import React from 'react';
import SvgIcon from '../SvgIconWrapper';

interface VKRBeamIconProps {
  size?: number;
  color?: string;
}

const VKRBeamIcon: React.FC<VKRBeamIconProps> = (props) => (
  <SvgIcon {...props} className="sx-icon-vkrbeam">
    {
      <path d="M19.593 3.005h-15.187c-0.774 0-1.402 0.628-1.402 1.402v15.187c0 0.774 0.628 1.402 1.402 1.402h15.187c0.774 0 1.402-0.628 1.402-1.402v-15.187c0-0.774-0.628-1.402-1.402-1.402zM19.703 18.503c0 0.663-0.537 1.2-1.2 1.2h-13.005c-0.663 0-1.2-0.537-1.2-1.2v-13.005c0-0.663 0.537-1.2 1.2-1.2h13.005c0.663 0 1.2 0.537 1.2 1.2v13.005z"></path>
    }  </SvgIcon>
);

export default VKRBeamIcon;
